import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Preloader from './components/layouts/Preloader';
import MyRestSettings from './components/MyPages/RestsP/MyRestSettings';
import MyCategurys from './components/MyPages/CategurysP/MyCategurys';
import MasterSettings from './components/MyPages/MasterP/MasterSettings';
import MyRestaurantlist from './components/MyPages/RestsP/Restaurantlist';
import HomePage from './components/MyPages/HomeP/HomePage';
import ManagmentPage from './components/MyPages/ManagmentP/ManagmentPage';
import Orderslist from './components/MyPages/OrdersP/Orderslist';
import WrapRegister from './components/MyPages/Login/Register/WrapRegister';
import UsersListP from './components/MyPages/UsersP/UsersListP';

import BuisUserprofile from './components/MyPages/Login/Userprofile/BuisUserprofile';
import ResetPasswordPage from './components/MyPages/Login/ResetPasswordP/ResetPasswordPage';
import ImageGall from './components/MyPages/MediaPage/ImageGall';
import MyInvoice from './components/MyPages/OrdersP/OrderItem/Invoice/Invoice';
import SinglePage from './components/MyPages/SinglePage/SinglePage';
import utilsSinglePage from './MyConns/_Utils/utilsSinglePage';
import utilsContactPage from './MyConns/_Utils/utilsContactPage';
import ContactPage from './components/MyPages/ContactPage.js/ContactPage';
import SingleSect from './components/MyPages/SingleSection/SingleSect';
import { SectionsContext } from './components/MyContexts/Sections_Context';
import TheLogin from './components/MyPages/Login/Login/TheLogin';
import TblOrderslist from './components/MyPages/TblOrdersP/TblOrderslist';
import TabMenu from './components/MySections/Rests/parts/TabMenu';
import MenuPlace from './components/MyPages/MenuP/MenuPlace';
import ClientUsersListP from './components/MyPages/ClientUsers/ClientUsersListP';
import ClientUserItemWrap from './components/MyPages/ClientUsers/ClientUserItemWrap';

const App = (props) => {
  const [Sections, setSections] = useContext(SectionsContext);
  const [lstSimpePages, setLstSimpePages] = useState([]);
  const [lstContactPages, setLstContactPages] = useState([]);

  useEffect(() => {
    getSimplePages();
    getContactPages();
  }, [])


  const getSimplePages = async () => {
    let tempo = await utilsSinglePage.allPgsNames();
    setLstSimpePages(tempo)

  }

  const upsSimpleList = (newitm) => {

    let tempo = [...lstSimpePages]
    tempo.push(newitm);
    setLstSimpePages(tempo)
  }


  const upsPageSections = (newitm) => {

    let tempo = [...Sections]
    tempo.push(newitm);
    setSections(tempo)

  }

  const getContactPages = async () => {
    let tempo = await utilsContactPage.allPgsNames();
    setLstContactPages(tempo)

  }


  const upContactList = (newitm) => {

    let tempo = [...lstContactPages]
    tempo.push(newitm);
    setLstContactPages(tempo)

  }



  return (
    <Router>
      <Preloader />
      <Switch>
        {/* <Route exact path="/" component={MyDashboard} /> */}
        {/* <Route exact path="/" component={TblOrderslist} /> */}
        <Route exact path="/" component={Orderslist} />
        <Route path="/Orders" component={Orderslist} />
        <Route path="/Order/:id" component={MyInvoice} />
        <Route path="/TblOrders" component={TblOrderslist} />
        <Route path="/Master" component={MasterSettings} />
        <Route path="/Login" component={TheLogin} />
        <Route path="/Register"><WrapRegister /></Route>
        <Route path="/Rests" component={MyRestaurantlist} />
        <Route path="/HomeP" component={HomePage} />
        <Route path="/Rest/:id" component={MyRestSettings} />
        <Route path="/Rest" component={MyRestSettings} />
        <Route path="/Menu" component={MenuPlace} />
        {/* <Route path="/Order/:id" component={OrderItem} /> */}
        <Route path="/allCats" component={MyCategurys} />
        <Route path="/Manage" component={ManagmentPage} />
        <Route path="/UsrPofile" component={BuisUserprofile} />
        <Route path="/ImageGall" component={ImageGall} />
        <Route path="/resPass" component={ResetPasswordPage} />
        <Route path="/Users" component={UsersListP} />
        <Route exact path="/ClientUsers" component={ClientUsersListP} />
        <Route path="/ClientUsers/:id" component={ClientUserItemWrap} />

        {lstSimpePages?.map((item, index) => {
          return (
            <Route key={`${index}_rout`} path={`/${item.inLinkToPage}`} >
              <SinglePage key={index} pageItem={item} upSimplsList={(newitm) => upsSimpleList(newitm)} />
            </Route>)
        })}


        <Route path="/nswSp">
          <SinglePage key={"np"} newp={true} pageItem={""} upSimplsList={(newitm) => upsSimpleList(newitm)} />
        </Route>

        {Sections?.map((item, index) => {
          return (
            <Route key={`${index}_rout`} path={`/${item.inLinkToPage}`} >
              <SingleSect key={index} pageItem={item} upSimplsList={(newitm) => upsPageSections(newitm)} />
            </Route>)
        })}


        <Route path="/nswPSec">
          <SingleSect key={"nswPSec"} newp={true} pageItem={""} upSimplsList={(newitm) => upsPageSections(newitm)} />
        </Route>


        {lstContactPages?.map((item, index) => {

          return (
            <Route key={`${index}_rout1`} path={`/${item.inLinkToPage}`} >
              <ContactPage key={index} pageItem={item} upContactList={(newitm) => upContactList(newitm)} />
            </Route>
          )
        })}

        <Route path="/nswContP">
          <ContactPage key={"nswSp"} newp={true} pageItem={""} upContactList={(newitm) => upContactList(newitm)} />
        </Route>


        {/* <Route component={MyDashboard} /> */}

      </Switch>
    </Router>

  );
}

export default App;
